<div data-aos-easing="ease" data-aos-duration="400" data-aos-delay="0">
  <rc-header></rc-header>
  <router-outlet></router-outlet>
</div>